<template>
  <div class="featured-reviews__container">
    <div class="featured-reviews__content">
      <div class="featured-reviews__heading">
        <Comas />
        <Heading size="h3">
          {{ $t('pages.reviews.featured_reviews.title') }}
        </Heading>
      </div>
      <Swiper
        :slides="swiperSlices"
        :slides-per-group="1"
        :space-between="24"
        :phablet-break-point-slides-per-group="2"
      />
    </div>
  </div>
</template>

<script>
import CardFeatureReview from './CardFeatureReview'

import Comas from '@/components/pages/features/common/reviews/svg/Comas'
import Heading from '@/components/common/Heading/Heading'
import Swiper from '@/components/common/Swiper/Swiper'

export default {
  components: {
    Heading,
    Comas,
    Swiper
  },

  data () {
    return {
      swiperSlices: [
        {
          component: CardFeatureReview,
          props: {
            imageUrl: '/images/reviews/lisa_w_miller.png',
            author: 'Lisa W. Miller',
            media: 'Bring More Joy',
            body: 'RSS has been integral to the success of my Bring More Joy to the Table business podcast! The platform is user-friendly, and I love being able to post to every streaming platform with just one click.'
          }
        },
        {
          component: CardFeatureReview,
          props: {
            imageUrl: '/images/reviews/steve_phillips.png',
            author: 'Steve Phillips',
            media: 'GeekCast Radio',
            body: "RSS.com has been a great resource after hunting and switching from other platforms. The forward-thinking, innovative manner with which they operate and the fact that they are affordable, full of features, and don't have crazy limits on podcasters with a network or huge back catalog. I recommend that all podcasters give these guys a shot and see how they can help you with your podcast hosting"
          }
        },
        {
          component: CardFeatureReview,
          props: {
            imageUrl: '/images/reviews/arielle_nissenblatt.png',
            author: 'Arielle Nissenblatt',
            media: 'Feedback with EarBuds',
            body: 'The number one thing I look for in a hosting provider is ease-of-use. Number two is clearly-defined analytics. If those are important things for you, too, RSS.com is the way to go.'
          }
        },
        {
          component: CardFeatureReview,
          props: {
            imageUrl: '/images/reviews/jake_fuller.png',
            author: 'Jake Fuller',
            media: 'Profitable Performance Marketing',
            body: "Having used the RSS.com platform for nearly 5 years, I can confidently say we’ve been thrilled with the service. They make podcast hosting and distribution incredibly easy, and we can't imagine running our show without it. With their top-notch service, excellent support, and unbeatable pricing, we're huge fans of RSS.com and highly recommend them to anyone looking to start or grow a podcast."
          }
        },
        {
          component: CardFeatureReview,
          props: {
            imageUrl: '/images/reviews/john_matarazzo.png',
            author: 'John Matarazzo',
            media: 'Charisma Podcast Network',
            body: "The Charisma Podcast's Network switch to RSS.com stands out as a pivotal decision for Charisma Media, one that has facilitated smoother operations, better content, and a stronger connection with our audience"
          }
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.featured-reviews {
  &__container {
    width: 100%;
    padding: $gap * 5 $gap;
    background-color: #25163a;
  }

  &__content {
    margin: 0 auto;
    width: 100%;
    max-width: 1120px;
    display: flex;
    flex-direction: column;
    gap: $gap * 2;
  }

  &__heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $gap;
  }
}
</style>
